import { isLogged } from '@/utils';

const guard = (to, from, next) => {
  const logged = isLogged();
  if (logged) {
    next('/');
  } else {
    next();
  }
};

export default guard;
